<template>
  <div>
    <SEOHead :title="seoData.title" :description="seoData.description" :keywords="seoData.keywords"
      :structured-data="seoData.structuredData" />
    <DownloadPC v-if="!isMobile" />
    <DownloadMobile v-else />
  </div>
</template>

<script>
import DownloadPC from './DownloadPC.vue'
import DownloadMobile from './DownloadMobile.vue'
import SEOHead from '@/components/SEOHead.vue'
import responsive from '@/utils/responsive'

export default {
  components: { DownloadPC, DownloadMobile, SEOHead },
  data() {
    return {
      responsive,
      seoData: {
        title: '七鼠智服下载 - AI智能客服系统软件下载 | 智寰科技',
        description: '下载智寰科技七鼠智服AI智能客服系统，支持Windows、iOS、Android等多平台。免费试用，快速部署，为您的电商业务提供专业的智能客服解决方案。',
        keywords: '七鼠智服下载,AI智能客服下载,智能客服系统下载,电商客服软件,智寰科技软件下载,客服系统安装',
        structuredData: {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "七鼠智服",
          "description": "基于千亿大模型的AI智能客服系统",
          "applicationCategory": "客服软件",
          "operatingSystem": ["Windows", "iOS", "Android", "Web"],
          "author": {
            "@type": "Organization",
            "name": "智寰科技"
          },
          "publisher": {
            "@type": "Organization",
            "name": "智寰科技"
          },
          "downloadUrl": "https://zhihuanai.com/download",
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "CNY",
            "description": "免费试用版本"
          },
          "featureList": [
            "AI全天自动模式",
            "AI人机协同",
            "多平台聚合管理",
            "AI自主营销",
            "图像识别与多媒体回复",
            "语音消息实时解析",
            "商品链接智能处理"
          ]
        }
      }
    }
  },
  computed: {
    isMobile() {
      return this.responsive.isMobile
    }
  }
}
</script>

<style scoped>
.page-content {
  padding: 100px 20px 60px 20px;
  text-align: center;
}
</style>